import { useState } from "react";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { WEBINAR } from "../../data/content";
import { submitLead } from "../../utils/api";
import { Reveal, Eyebrow } from "../motion";

const EMPTY = { prenom: "", nom: "", email: "", telephone: "" };

export const Webinar = () => {
  const [form, setForm] = useState(EMPTY);
  const [done, setDone] = useState(false);
  const [sending, setSending] = useState(false);

  const set = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await submitLead(form);
      setDone(true);
      toast.success("Ta place est réservée. À très vite !");
    } catch {
      toast.error("Une erreur est survenue. Merci de réessayer.");
    } finally {
      setSending(false);
    }
  };

  return (
    <section id="webinaire" className="scroll-mt-20 py-24 lg:py-36" data-testid="section-webinaire">
      <div className="mx-auto max-w-[1500px] px-6 sm:px-10 lg:px-16">
        <Reveal>
          <div className="grid gap-12 border border-neon/25 bg-gradient-to-br from-card via-[#1D1327] to-ink p-8 sm:p-12 lg:grid-cols-2 lg:p-16">
            <div>
              <Eyebrow>{WEBINAR.eyebrow}</Eyebrow>
              <h2 className="mt-6 font-serif text-4xl leading-[1.1] text-cream sm:text-5xl">{WEBINAR.title}</h2>
              <p className="mt-6 max-w-md leading-relaxed text-white/60">{WEBINAR.subtitle}</p>
              <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.25em] text-neon-light">{WEBINAR.tagline}</p>
              <div className="mt-8 overflow-hidden rounded border border-white/10 lg:max-w-sm">
                <img src={WEBINAR.visual} alt="Demoiselle Atypique — Logo de la marque" className="h-full w-full object-cover" />
              </div>
              <p className="mt-6 max-w-md text-sm leading-relaxed text-white/45">{WEBINAR.note}</p>
            </div>

            {done ? (
              <div className="flex flex-col items-start justify-center gap-4 border border-neon/40 bg-white/[0.02] p-8" data-testid="webinar-success">
                <p className="font-serif text-3xl text-neon-light">Merci, c'est noté.</p>
                <p className="text-sm leading-relaxed text-white/60">
                  Ton inscription est confirmée. Tu recevras toutes les informations par e-mail dès que la prochaine
                  session sera programmée.
                </p>
              </div>
            ) : (
              <form onSubmit={onSubmit} data-testid="webinar-signup-form" className="flex flex-col gap-5">
                <div className="grid gap-5 sm:grid-cols-2">
                  <div>
                    <label htmlFor="web-prenom" className="field-label">Prénom</label>
                    <input id="web-prenom" data-testid="webinar-input-prenom" className="field" required value={form.prenom} onChange={set("prenom")} placeholder="Camille" />
                  </div>
                  <div>
                    <label htmlFor="web-nom" className="field-label">Nom</label>
                    <input id="web-nom" data-testid="webinar-input-nom" className="field" required value={form.nom} onChange={set("nom")} placeholder="Durand" />
                  </div>
                  <div>
                    <label htmlFor="web-email" className="field-label">E-mail</label>
                    <input id="web-email" data-testid="webinar-input-email" type="email" className="field" required value={form.email} onChange={set("email")} placeholder="camille@exemple.fr" />
                  </div>
                  <div>
                    <label htmlFor="web-tel" className="field-label">Téléphone</label>
                    <input id="web-tel" data-testid="webinar-input-telephone" type="tel" className="field" required value={form.telephone} onChange={set("telephone")} placeholder="06 12 34 56 78" />
                  </div>
                </div>
                <button type="submit" disabled={sending} data-testid="webinar-submit" className="btn-primary mt-2 w-full disabled:opacity-60">
                  {sending ? "Envoi..." : WEBINAR.cta} <ArrowRight className="h-4 w-4" />
                </button>
                <p className="text-xs leading-relaxed text-white/35">
                  En t'inscrivant, tu acceptes de recevoir nos communications concernant le webinaire. Désinscription en
                  un clic.
                </p>
              </form>
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
